module.exports = "https://r.nearpod.com/assets/media/image/user_yellow_icon-03415ea1c6fe81cbed4465b98c8fa7e0.svg";